import { updateField } from 'vuex-map-fields';

function juneIdentifyUser(state) {
  if (window.analytics && window.analytics.identify) {
    window.analytics.identify(state.id, {
      email: state.email,
    });
  } else {
    setTimeout(() => {
      juneIdentifyUser(state);
    }, 5000);
  }
}

function ga4setUserEmail(state) {
  if (window.sbgtag) {
    // window.sbgtag.set({
    //   user_email_custom: state.email,
    // });
    window.sbgtag.config({
      user_id: state.id,
    });
    // window.sbgtag.customMap({ user_email_custom: state.email });
    window.sbgtag.query('set', 'user_properties', {
      user_email_custom: state.email,
    });
  } else {
    setTimeout(() => {
      ga4setUserEmail(state);
    }, 5000);
  }
}

export default {
  SET_USER(state, payload) {
    state.email = payload.email;
    state.phone = payload.phone;
    state.phoneCountryCode = payload.phone_country_code;
    state.phoneVerified = payload.phone_verified;
    state.firstName = payload.first_name;
    state.lastName = payload.last_name;
    state.name = payload.name;
    state.avatar = payload.avatar;
    state.available = payload.available;
    state.card = payload.card;
    state.id = payload.id;
    state.lastUserId = payload.id;
    state.invitations_accepted = payload.invitations_accepted;
    state.incognito = payload.incognito;
    state.permissions = { ...state.permissions, ...payload.permissions };
    state.region = payload.region || 'HR'; // TODO consider checking the region and if it doesn't exist notify us and set default
    state.role = payload.role;
    state.platformId = payload.platform_id;
  },
  SET_EMAIL(state, value) {
    state.email = value;
  },
  CLEAR_INVITATIONS(state) {
    state.invitations_accepted = [];
  },
  USER_LOADED(state, payload) {
    state.userLoaded = payload;
    juneIdentifyUser(state);
    ga4setUserEmail(state);
  },
  AUTH_SUCCESS(state, payload) {
    state.authenticated = true;
    localStorage.setItem('pbdToken', payload.token);
    localStorage.setItem('userId', payload.id);
  },
  SET_SUCCESS_UPDATE(state, payload) {
    state.successUpdate = payload;
  },
  SET_AVATAR(state, payload) {
    state.avatar = payload;
  },
  SET_SUCCESS_EMAIL_UPDATE(state, payload) {
    state.successEmailUpdate = payload;
  },
  SET_SUCCESS_PASSWORD_UPDATE(state, payload) {
    state.successPasswordUpdate = payload;
  },
  SET_SUCCESS_PHONE_UPDATE(state, payload) {
    state.successPhoneUpdate = payload;
  },
  SET_USER_AVAILABILITY(state, payload) {
    state.available = payload;
  },
  SET_MERCHANT_ROLES(state, payload) {
    localStorage.setItem('merchantRoles', JSON.stringify(payload));
  },
  USER_SETTINGS_LOADING(state, status) {
    state.userSettingsLoading = status;
  },
  SET_USER_SETTINGS(state, payload) {
    state.settings = payload;
  },
  SET_SUCCESS_SETTINGS_UPDATE(state, payload) {
    state.settingsUpdated = payload;
  },
  INVITATION_ACCEPTED(state) {
    state.invitationAccepted = true;
  },
  PASSWORD_RESET_SENT(state, payload) {
    state.passwordResetSent = payload;
  },
  PAYMENT_CARD_CHANGED(state, payload) {
    state.paymentCardChanged = payload;
  },
  ONESIGNAL_ID_ADDED(state) {
    state.oneSignalIdAdded = true;
  },
  ONESIGNAL_ID_REMOVED(state) {
    state.oneSignalIdRemoved = true;
  },
  USER_SIGNED_OUT(state) {
    state.userSignedOut = true;
  },
  SET_CHECKING_PASSWORD(state, payload) {
    state.checkingPassword = payload;
  },
  PHONE_VERIFY_FINISHED(state, status) {
    state.phoneVerifyFinished = status;
  },
  DELETING_PHONE_IN_PROGRESS(state, status) {
    state.deletingPhoneInProgress = status;
  },
  API_ERROR(state, payload) {
    if (payload) {
      state.apiError = payload;
    }
  },
  CLEAR_API_ERROR(state) {
    state.apiError = {};
  },
  SET_PERMISSION_DENIED(state, payload) {
    state.permissionDenied = payload;
  },
  RESET_ACCESS(state) {
    state.permissionDenied = {};
  },
  updateField,
};
